export const alphabeticalSort = (a, b) => {
  if (a.displayName < b.displayName) {
    return -1;
  } else if (a.displayName > b.displayName) {
    return 1;
  }
  return 0;
};
